import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import _ from "i18n";

export default class TTPPaginator extends Component {
  render() {
    const {
      onPageChange,
      pageSize,
      nbResult,
      cssClass,
      paginationPage,
      pageCount
    } = this.props;

    return (
      <ReactPaginate
        previousLabel={_("previous")}
        nextLabel={_("next")}
        breakLabel={<span href="">...</span>}
        breakClassName={""}
        pageCount={pageCount ? pageCount : Math.ceil(nbResult / pageSize)}
        marginPagesDisplayed={1}
        pageRangeDisplayed={5}
        onPageChange={onPageChange}
        containerClassName={"pagination"}
        subContainerClassName={`pages pagination ${cssClass}`}
        activeClassName={"current"}
        pageClassName="page"
        forcePage={paginationPage - 1}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/TTPPaginator.js